import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DestinationGrid } from '../components/DestinationGrid';
import { destinationsByNetwork } from '../lib/destinations';

export function DestinationsPage() {
  const { kind = '' } = useParams();
  const { t } = useTranslation();
  const network = kind === 'domestic' || kind === 'international' ? kind : null;

  if (!network) {
    return (
      <main className="sa-page">
        <div className="sa-container" style={{ maxWidth: '40rem' }}>
          <h1 className="sa-headline">{t('nav.missing')}</h1>
          <Link to="/" className="sa-button sa-button--ghost">
            {t('common.brand')}
          </Link>
        </div>
      </main>
    );
  }

  const items = destinationsByNetwork(network);

  return (
    <main className="sa-page">
      <div className="sa-container">
        <div className="sa-page__header">
          <p className="home-section__eyebrow">{t('nav.groups.destinations')}</p>
          <h1 className="sa-headline">{t(`nav.items.${network}`)}</h1>
          <p className="sa-text-muted">{t(`nav.copy.${network}`)}</p>
        </div>
        <DestinationGrid items={items} />
      </div>
    </main>
  );
}
